import axios from 'axios'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { formatISO } from "date-fns";

const initialState = {
  data: {},
  status: 'idle',
  errors: null,
  last_refresh: null,
  api_tries: 0,
  spoofed_user: {},
  filtered_portfolio: null,
  timeoutReset: 0, // Increment by 1 each time the timeout needs to be reset
  timeoutCount: 1 // Number of times the timeout has been restarted
}

export const fetchUserInfo = createAsyncThunk(
  'user/fetchUser',
  async (accessToken) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_DOMAIN}/user/current_user`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
    return response.data.data
  }
)

export const fetchSpoofedUserInfo = createAsyncThunk(
  'user/fetchSpoofedUser',
  async (props) => {
    const { accessToken, spoofed_user_id } = props
    const response = await axios.get(
      `${process.env.REACT_APP_API_DOMAIN}/user/current_user?spoofUserID=${spoofed_user_id}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
    return response.data.data
  }
)

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setSpoofedUser: (state, action) => {
      state.spoofed_user = action.payload.spoofed_user
    },
    setFilteredPortfolio: (state, action) => {
      state.filtered_portfolio = action.payload.filtered_portfolio
    },
    incrementTimeoutCount: (state) => {
      state.timeoutCount += 1
    },
    setTimeoutReset: (state, action) => {
      state.timeoutReset += 1
      state.timeoutCount = 1
    },
    resetTimeoutCount: (state, action) => {
      state.timeoutCount = 1
    }
  },
  extraReducers(builder) {
    builder
      .addCase(fetchUserInfo.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(fetchUserInfo.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        state.last_refresh = formatISO(new Date())
        state.api_tries = 0
      })
      .addCase(fetchUserInfo.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
        state.api_tries += 1
      })
      .addCase(fetchSpoofedUserInfo.fulfilled, (state, action) => {
        state.spoofed_user = action.payload
      })
  },
})

export const { resetTimeoutCount, setTimeoutReset, incrementTimeoutCount, setSpoofedUser, setFilteredPortfolio } = userSlice.actions
export const selectUser = (state) => state.user
export default userSlice.reducer
